<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import (Create or Update)  Supplies"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create or update supplies."
      @on-submit="createSupplyImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Supplies Template.xlsx"
              :file-provider="$importsAPI.getSuppliesTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'SuppliesImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'supplies-imports-add-modal',
    };
  },
  methods: {
    createSupplyImport(data, handleCreate) {
      handleCreate(this.$importsAPI.suppliesCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
